import { DateFilterType, FiltersSettings } from './types';

const isDateFilter = (
  name: keyof FiltersSettings,
  value: FiltersSettings[typeof name]
): value is DateFilterType => name === 'date';

export const areSomeFiltersActive = (obj: FiltersSettings) =>
  Object.keys(obj).some(
    (key: keyof FiltersSettings) => !isFilterEmpty(key, obj[key])
  );

export const areFiltersEmpty = (obj: FiltersSettings) =>
  !areSomeFiltersActive(obj);

export const isFilterEmpty = (
  filterName: keyof FiltersSettings,
  filterValue: FiltersSettings[typeof filterName]
) => {
  if (isDateFilter(filterName, filterValue)) {
    if (filterValue.type === 'relative') {
      return filterValue.value === 0;
    } else {
      return !filterValue.endDate && !filterValue.startDate;
    }
  }
  return filterValue.length === 0;
};
